import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const BenefitsSection = () => {
  return <section id="benefits" className="py-20 px-6 md:px-12 bg-teal-50" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <h2 className="text-3xl md:text-4xl font-bold text-teal-900 text-center mb-16" data-id="element-16">
          Here's What You Get:
        </h2>
        <div className="grid md:grid-cols-2 gap-10" data-id="element-17">
          <div className="bg-white p-8 rounded-xl shadow-md" data-id="element-18">
            <div className="flex items-center mb-6" data-id="element-19">
              <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-20">
                <CheckCircleIcon className="h-8 w-8 text-teal-700" data-id="element-21" />
              </div>
              <h3 className="text-2xl font-bold text-teal-800" data-id="element-22">
                For You (The Practitioner):
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-23">
              <li className="flex items-start" data-id="element-24">
                <span className="text-teal-700 font-bold mr-2" data-id="element-25">✓</span>
                <span data-id="element-26">Lifetime access to all Neurotoned programs</span>
              </li>
              <li className="flex items-start" data-id="element-27">
                <span className="text-teal-700 font-bold mr-2" data-id="element-28">✓</span>
                <span data-id="element-29">All future updates + bonus releases</span>
              </li>
              <li className="flex items-start" data-id="element-30">
                <span className="text-teal-700 font-bold mr-2" data-id="element-31">✓</span>
                <span data-id="element-32">Early founder rate: $499/year (renews annually)</span>
              </li>
              <li className="flex items-start" data-id="element-33">
                <span className="text-teal-700 font-bold mr-2" data-id="element-34">✓</span>
                <span data-id="element-35">
                  Therapist Directory Listing on our Body-Based Healing Network
                </span>
              </li>
              <li className="flex items-start" data-id="element-36">
                <span className="text-teal-700 font-bold mr-2" data-id="element-37">✓</span>
                <span data-id="element-38">Setup support: We onboard your clients for you</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md" data-id="element-39">
            <div className="flex items-center mb-6" data-id="element-40">
              <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-41">
                <CheckCircleIcon className="h-8 w-8 text-teal-700" data-id="element-42" />
              </div>
              <h3 className="text-2xl font-bold text-teal-800" data-id="element-43">
                For Your Clients (Unlimited Accounts):
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-44">
              <li className="flex items-start" data-id="element-45">
                <span className="text-teal-700 font-bold mr-2" data-id="element-46">✓</span>
                <span data-id="element-47">Their own private logins to all programs</span>
              </li>
              <li className="flex items-start" data-id="element-48">
                <span className="text-teal-700 font-bold mr-2" data-id="element-49">✓</span>
                <span data-id="element-50">
                  Biweekly live group support calls with Neurotoned facilitators
                </span>
              </li>
              <li className="flex items-start" data-id="element-51">
                <span className="text-teal-700 font-bold mr-2" data-id="element-52">✓</span>
                <span data-id="element-53">Optional healing community access</span>
              </li>
              <li className="flex items-start" data-id="element-54">
                <span className="text-teal-700 font-bold mr-2" data-id="element-55">✓</span>
                <span data-id="element-56">Zero additional cost per client</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};
export default BenefitsSection;